import React from "react";
import {
  StepCard,
  StepTitle,
  StepSubtitle,
  FormGroup,
  SelectableCardsGrid,
  SelectableCard,
  NavigationButtonsRow,
  ActionButton,
} from "../registerStyles";

const DOCTORES_OPTIONS = [
  { id: "1", icon: "👤", title: "Solo yo", desc: "1 odontólogo principal" },
  { id: "2", icon: "👥", title: "Somos 2", desc: "2 odontólogos en el consultorio" },
  { id: "3_5", icon: "👨‍👩‍👧‍👦", title: "De 3 a 5", desc: "Equipo de 3 a 5 odontólogos" },
  { id: "more_5", icon: "🏢", title: "Más de 5", desc: "Clínica con más de 5 doctores" },
];

export const StepDiagnosisDoctores = ({
  formData,
  setFormData,
  onNext,
  onBack,
}) => {
  const isSelected = Boolean(formData.numDoctores);

  return (
    <StepCard>
      <StepTitle>¿Cuántos doctores hay en tu equipo?</StepTitle>
      <StepSubtitle>
        Esto nos ayuda a dimensionar el plan adecuado para tu consultorio.
      </StepSubtitle>

      <FormGroup>
        <SelectableCardsGrid columns={2}>
          {DOCTORES_OPTIONS.map((opt) => {
            const selected = formData.numDoctores === opt.id;
            return (
              <SelectableCard
                key={opt.id}
                selected={selected}
                onClick={() => {
                  setFormData({ ...formData, numDoctores: opt.id });
                  onNext("numDoctores", opt.id);
                }}
              >
                <div className="icon-wrapper">{opt.icon}</div>
                <h4 className="card-title">{opt.title}</h4>
                <p className="card-description">{opt.desc}</p>
              </SelectableCard>
            );
          })}
        </SelectableCardsGrid>
      </FormGroup>

      <NavigationButtonsRow>
        <ActionButton type="button" onClick={onBack}>
          ← Atrás
        </ActionButton>
      </NavigationButtonsRow>
    </StepCard>
  );
};
